import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { Observable } from "rxjs/Rx"
import { catchError, map, tap } from 'rxjs/operators';
import { throwError  } from 'rxjs';
import { environment } from '../../environments/environment'


@Injectable()
export class LandingpageService {
  options: any;
  //headers: HttpHeaders;

//data1={role:"admin", type:"GA Homepage"}
  
  constructor(private _http:HttpClient) {
    this.options = {
      Observe: 'response',
      headers: new HttpHeaders({
        'Content-type': 'application/json'
      })
    };
   }

  getData(){
    return this._http.get(
      environment.restAPI + 'access/home',
      this.options
    ).pipe(
      map(
      (res: any) => {
        const role_id = localStorage.getItem('role_id');
        console.log('KAjal');
        // console.log('response ' + JSON.stringify(res));
        //if(res.status == 304) {
          // return from localstorage
        //  if(!role_id)
        //    throw new Error('RoleID missing');
        //  var result = JSON.parse(localStorage.getItem('home:'+role_id));
        //  return result;
        //}
       // else if(res.status == 200) {
          // store data in localstorage
        if (res && res.elements) {
          localStorage.setItem('home:' + role_id, JSON.stringify(res));
          return res;
        } else {
          throw new Error('Request failed ');
        }
      }
      ),catchError((error: any) => throwError(error || 'Server error')));
  }

}
